import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_position_entry_hire = () => {
  useAuthRedirect();
  const { vcode, branch, vehname, vehno, vtype, basis } = useParams();

  const navigate = useNavigate();

   const [serialNo, setSerialNo] = useState([]);
    const [data, setData] = useState([]);
      const [loading, setLoading] = useState(false);
   const [tyre_id, setTyreId] = useState("");
   const storedUser = localStorage.getItem("username");
   const [selectedTyre, setSelectedTyre] = useState(null);
  const [formData, setFormData] = useState({
    vcode: "",
    branch: "",
    tyre_model: "",
    tyre_make: "",
    tyre_type: "",
    tyre_amount: "",
    remarks: "",
    fitting: "",
    fitting_date: "",
    serialNo: "",
    position: "",
    user: "",
  });

  const canView  = hasPermission("Tyre Maintenance Details", "view");
        const canEntry = hasPermission("Tyre Maintenance Details", "entry");
        const canDel   = hasPermission("Tyre Maintenance Details", "del");
    

  useEffect(() => {
    fetchSerailNo();
  }, []);



    const fetchSerailNo = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/tyre_serialNo");
        setSerialNo(response.data.serialNo);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    useEffect(() => {
        if (tyre_id) {
          fetchTyreDetails(tyre_id);
        }
      }, [tyre_id]);

    const fetchTyreDetails = async (tyre_id) => {
        if (!tyre_id) {
            setSelectedTyre(null);
            return;
        }
        try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/tyre_details/${tyre_id}`);
            setSelectedTyre(response.data.tyreDetails);
        } catch (error) {
            console.error("Error fetching tyre details:", error);
        }
    };
    
    useEffect(() => {
        if (vcode) {
          setLoading(true);
          axios.get(`https://rfs2.infraconsoft.net.in/api/tyre_tableData?vcode=${vcode}`)
            .then((response) => {
              setData(response.data.vehicles);
            })
            .catch((error) => {
              console.error("Error fetching vehicles:", error);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      }, [vcode]); 

      const handleRemove = async (tyre) => { // Changed tyre_id to tyre
        if (window.confirm("Are you sure you want to remove this tyre?")) {
            try {
              Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });

                const response = await axios.post("https://rfs2.infraconsoft.net.in/api/remove_tyre", {
                    removeId: tyre.tyre_id, // Corrected parameter access
                    vcode: vcode, // Ensure vcode exists in tyre object
                    tyre_no: tyre.tyre_no,
                    remove_tyrerate: tyre.tyre_amount,
                    remove_date: new Date().toISOString().split("T")[0], 
                    remove_km: tyre.fitting_km,
                    branch: tyre.tyre_branch,
                    user: storedUser,
                });
    
                console.log("Server Response:", response.data); // Log server response
    
                if (response.data.success) {
                  Swal.fire({
                    title: "Success!",
                    text: "Tyre removed successfully!",
                    icon: "success",
                    width: "500px",
                    height: "40vh",
                    draggable: true,
                })
                    window.location.reload();
                } else {
                    alert("Error from server: " + response.data.error);
                    console.error("Server Error Response:", response.data);
                }
            } catch (error) {
                console.error("Remove Error:", error.response ? error.response.data : error.message);
                alert("Failed to remove tyre.");
            }
        }
    };
    

//   Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Validations before submitting
  if (!formData.serialNo || formData.serialNo.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select Tyre Serial.",
    });
    return;
  }

  if (!formData.fitting || isNaN(formData.fitting) || Number(formData.fitting) <= 0) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Input",
      text: "Enter Fitting hour. It should be a positive number and not zero.",
    });
    return;
  }

  if (!formData.fitting_date) {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please enter fitting date.",
    });
    return;
  }

  if (!formData.position || formData.position.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Missing Field",
      text: "Please select position.",
    });
    return;
  }

  // ✅ If validation passes, prepare payload
  const payload = {
    vcode,
    branch,
    user: storedUser,
    tyre_model: selectedTyre.tyre_model,
    tyre_make: selectedTyre.tyre_make,
    tyre_type: selectedTyre.tyre_type,
    tyre_amount: selectedTyre.tyre_amount,
    remarks: formData.remarks,
    fitting: formData.fitting,
    fitting_date: formData.fitting_date,
    serialNo: formData.serialNo,
    position: formData.position,
  };

  console.log("Submitting Payload:", payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/insert_tyre",
      payload
    );

    console.log(response);

    Swal.fire({
      title: "Success!",
      text: "Tyre Maintenance inserted successfully.",
      icon: "success",
      width: "500px",
      height: "40vh",
      draggable: true,
    }).then(() => {
      navigate(`/tyreadd_vehicle/${basis}/${vcode}/${branch}`);
      window.location.reload();
    });

  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire({
      icon: "error",
      title: "Insert Failed",
      text: "Submission failed. Please try again.",
    });
  }
};

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
            <h2 className="add-txt">Tyre Maintenance Entry</h2>
            <Link to='/tyre_maintenance'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <div>
            <Time />
          </div>
        </section>

{canEntry && (
        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branch" value={branch} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                  <label>Tyre Serial No :</label>
                  <select
  name="serialNo"
  onChange={(e) => {
    handleChange(e); 
    fetchTyreDetails(e.target.value);
    setFormData((prevData) => ({
      ...prevData,
      serialNo: e.target.value, 
    }));
  }}
>
  <option value="">-- Select one --</option>
  {serialNo.map((row, index) => (
    <option key={index} value={row.tyre_id}>
      {row.tyre_seriolno}
    </option>
  ))}
</select>


                </div>
                <div className="form-group">
                  <label>Remarks :</label>
                  <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
                </div>
              </div>

              <div className="form-row">
              <div className="form-group">
                <label>Tyre Model :</label>
                <input type="text" name="tyre_model" value={selectedTyre?.tyre_model || ""} />
              </div>
              <div className="form-group">
                <label>Tyre Make :</label>
                <input type="text"name="tyre_make" value={selectedTyre?.tyre_make || ""}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Tyre type :</label>
                <input type="text" name="tyre_type" value={selectedTyre?.tyre_type || ""}/>
              </div>
              <div className="form-group">
                <label>Tyre amount :</label>
                <input type="text" name="tyre_amount" value={selectedTyre?.tyre_amount || ""}  />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
              <label>Fitting {basis === "Hour" ? "Hour" : "KM"} :</label>
                <input type="text" name="fitting" value={formData.fitting} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Fitting Date :</label>
                <input type="date" name="fitting_date" value={formData.fitting_date} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
              <label> Position :</label>
              <select name="position" value={formData.position} onChange={handleChange}>
  <option value="">-- Select Position --</option> 
  <option value="Front-left">Front-left</option>
  <option value="Front-Right">Front-Right</option>
  <option value="housing-left">Housing-left</option>
  <option value="housing-right">Housing-right</option>
  <option value="Rear-left">Rear-left</option>
  <option value="Rear-right">Rear-right</option>
</select>

              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
)}



        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Tyre No</th>
                <th>Branch</th>
                <th>Original/RTD</th>
                <th>Fitting Date</th>
                <th>Fitting {basis}</th>
                <th>Running {basis}</th>
                <th>Rate</th>
                <th>Tyre Cost {basis}</th>
                <th>Remarks</th>
                {/* {canDel && ( */}
                <th>Remove</th>
                {/* )} */}
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="7" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => {
      let total;
      if (basis === "Hour") {
        total = item.hours + item.cumulative;
      } else {
        total = item.Wokm + item.cumulative;
      }

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.tyre_seriolno}</td>
          <td>{item.tyre_branch}</td>
          <td>{item.tyre_type}</td>
          <td>{new Date(item.fitting_date).toLocaleDateString("en-GB")}</td>
          <td>{item.fitting_km}</td>
          <td>{total?.toLocaleString()}</td>
          <td>{item.tyre_amount}</td>
          <td>{item.tyre_amount}</td>
          <td>{item.tyre_remarks}</td>
          {canDel && (
          <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleRemove(item)}></i>
                    </td>
           )}
        
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="7">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;
